import {
  FeedRelatedItemWithConditions,
  RelatedItemsLogicsForFeed,
  RelateItemMapping,
  RemoteRelatedItemsLogicsForFeed,
} from './relatedItems.types';
import _startCase from 'lodash/startCase';
import {DateTime} from 'luxon';
import _some from 'lodash/some';
import getEmptyCondition from '../compoundConditions/utils/getEmptyCondition';

function toClientRelateItemsMapping({value, key}: {value: number; key: string}): RelateItemMapping {
  return {
    value: key,
    label: _startCase(key),
    isRequired: value !== -1,
  };
}

function toClientRelatedItemsLogicsForFeed(
  item: RemoteRelatedItemsLogicsForFeed,
): RelatedItemsLogicsForFeed {
  return {
    ...item,
    itemsCount: item.items_count,
    lastPopulatedDate: DateTime.fromISO(item.last_populated_date),
  };
}

export function clientRelatedItemsToRemote(
  item: FeedRelatedItemWithConditions,
): FeedRelatedItemWithConditions {
  const {condition} = item;

  if (
    _some(
      condition.sections,
      (section) => section.rules.length === 0 || _some(section.rules, (rule) => !rule.signal.value),
    )
  ) {
    return {
      ...item,
      condition: {sections: []},
    };
  }

  return item;
}

export function remoteRelatedItemsToClient(
  item: FeedRelatedItemWithConditions,
): FeedRelatedItemWithConditions {
  const {condition} = item;

  if (
    condition === null ||
    _some(
      condition.sections,
      (section) => section.rules.length === 0 || _some(section.rules, (rule) => !rule.signal.value),
    )
  ) {
    return {
      ...item,
      condition: getEmptyCondition(),
    };
  }

  return {
    ...item,
    condition: condition ? {...condition, sections: condition.sections ?? []} : getEmptyCondition(),
  };
}

export {toClientRelateItemsMapping, toClientRelatedItemsLogicsForFeed};
